import Button from "@mui/material/Button";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { useTranslation } from "react-i18next";
import { PRODUCTS_LIST } from "../../../locales/pages/namespaces";

export default function ShowMoreToggle({ expanded, onToggle,sx }) {
    const { t } = useTranslation(PRODUCTS_LIST);
    return (
        <Button
            disableRipple
            size="small"
            endIcon={expanded ? <KeyboardArrowUp sx={{ fontSize: 14 }} /> : <KeyboardArrowDown sx={{ fontSize: 14 }} />}
            onClick={() => onToggle(!expanded)}
            sx={{
                height: 17,                   // Figma
                minHeight: 17,
                lineHeight: 1,
                px: 0,
                color: '#E5007E',
                textTransform: 'uppercase',
                fontWeight: 900,
                fontSize: 14,
                alignSelf: 'flex-start',
                '& .MuiButton-endIcon': { ml: '4px' },  // gap = 4
                ...sx
            }}
        >
            {expanded ?  t("show less") : t("show more")} 
        </Button>
    );
}
